<!-- 讨论区list -->
<template>
  <div class="zlr-discuss-item-con">
    <div class="zlr-discuss-item-left">
      <img :src="avatar"
           alt="头像">
    </div>
    <div class="zlr-discuss-item-right">
      <div class="zlr-discuss-item-base">
        <div>{{ name }}</div>
        <div>{{time | fiterName}}</div>
      </div>
      <div class="zlr-discuss-item-html"
           v-html="content">
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'zlr-discuss-item',
  components: {},
  props: ['avatar', 'name', 'time', 'content'],
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {},
  filters: {
    fiterName (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
